<template>
  <div
    class="popover"
    :style="{top:popoverTop}"
    :id="'popover'+menu.id"
  >
    <div
      class="level2-box"
      v-for="level2 in menu.children"
      :key="level2.id"
    >
      <span class="title">{{level2.name}}</span>
      <div
        class="item-menu"
        v-if="level2.children.length>0"
      >
        <div
          class="level3-txt"
          v-for="level3 in level2.children"
          :key="level3.id"
          @click="changePage(level3)"
          :class="{'active':level3.url==$route.path}"
        >
          {{level3.name}}
        </div>
      </div>
      <div
        class="item-menu"
        v-else
      >
        <div
          class="level3-txt"
          :key="level2.id"
          @click="changePage(level2)"
          :class="{'active':level2.url==$route.path}"
        >
          {{level2.name}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["menu"],
  data() {
    return {
      popoverTop: 0,
    };
  },
  methods: {
    changePage(menu) {
      if (menu.url === this.$route.path) return;
      this.menuList = this.$utils.getUserMenu();
      this.menuList.map((item) => {
        if (item.url == menu.url) {
          this.level1Id = item.parentId;
          this.menuList.map((parent) => {
            if (item.parentId == parent.id) {
              this.level1Id = parent.parentId;
            }
          });
        }
      });
      this.currentMenu = menu;
      this.$utils.setCurrentMune(menu);
      this.addMenuList(menu);
      this.$router.push({ path: menu.url.trim() });
      this.$emit('setMenuActive',this.menu);
    },
    addMenuList(menu) {
      let menuList = this.$utils.getClickMenu();
      menuList.map((item) => {
        item.active = false;
      });
      let currentMenu = menuList.filter((item) => {
        return item.url === menu.url;
      });
      if (currentMenu.length === 0) {
        menu.active = true;
        menuList.push(menu);
      } else {
        currentMenu[0].active = true;
      }
      this.$utils.setClickMenu(menuList);
      this.$store.commit(this.$utils.storeKeys.CLICKMENU, menuList);
    },
    setPopoverTop() {
      this.$nextTick(() => {
        let popoverHeight = document.getElementById("popover" + this.menu.id)
          .offsetHeight;
        let menuTop = this.$utils.getTop(
          document.getElementById("menu" + this.menu.id)
        );
        let winHeight = document.body.clientHeight;
        if (winHeight-popoverHeight-100 < menuTop) {
          this.popoverTop =  (winHeight-popoverHeight-50)+"px";
        } else {
            this.popoverTop = menuTop+'px';
        }
      });
    },
  },
};
</script>
<style>
.popover {
  box-shadow: -3px -3px 5px rgba(69, 70, 72, 0.1),
    5px 3px 3px rgba(69, 70, 72, 0.1);
  position: absolute;
  width: 400px;
  left: 12.8rem;
  top: 0;
  padding:0 20px 20px 20px;
  display: flex;
  flex-direction: column;
  z-index: 10000;
  background: #ffffff;
  color: #383838;
  border-radius: 10px;
}
.popover .level2-box {
  border-bottom: 1px dashed #e8eaec;
}
.popover .level2-box .title {
  font-weight: bolder;
  font-size: 16px;
  position: relative;
  /*line-height: 36px;*/
  /*height: 36px;*/
  padding:15px 0 14px 15px;
  display: block;
}
.popover .level2-box .title::before {
  content: "·";
  font-weight: bolder;
  font-size: 24px;
  color: #458cff;
  position: absolute;
  left: 0;
  top: 6px;
  line-height: 40px;
}
.popover .level3-txt {
  cursor: pointer;
  margin-right: 10px;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  box-sizing: content-box;
  border-radius: 5px;
  /*margin-bottom: 10px;*/
  color: #999;
  font-size: 14px;
}
.popover .level3-txt:hover {
  color: #458cff;
}
.popover .level3-txt.active {
  background-color: #dcedff;
  color: #458cff;
}
.popover .item-menu {
  display: flex;
  flex-direction: row;
  font-size: 10px;
  flex-wrap: wrap;
}

.popover .item-menu span {
  display: flex;
  padding: 0 10px;
  font-size: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/business/menuPopover.vue